import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout-only route — index page lives in `case-studies.index.tsx` to
// avoid leaking a duplicate canonical/hrefLang into child detail pages.
export const Route = createFileRoute("/case-studies")({
  component: () => <Outlet />,
});
